import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

const Page2 = () => (
  <Layout title="読ム-1グランプリ　テンプレート">
    <Seo title="読ム-1グランプリ　テンプレート" />
    <p>
      漫才をしたい…でも人前に出るのは恥ずかしい…なら合成音声ソフトがあるじゃない！さぁ、読ム-1グランプリに参加しよう！！<br />
    </p>
    <h3>読ム-1とは</h3>
    <p>
      読ム-1グランプリはニコニコ動画上で開催される歌唱用の物を除く各種合成音声ソフトによる コンプラ無用（自己責任）のM-1グランプリオマージュのオリジナル漫才大会です。<br />
      参加者同士の投票によって最優秀賞が選出される今大会こそは、 合成音声ソフトの漫才大会における頂点の物であると言っても過言ではありません！ （他に無いですし）<br />
      <br />
      頂点を目指し日昼夜ひたすらネタを追い求め<br />
      暗い部屋の中孤独に浸る求道者となるも良し<br />
      そんな参加者達の骨身を削る争いを安全圏から悠々と鑑賞し<br />
      愚かな人間どもよと悦に至るも良し 　<br />
      <br />
      とにもかくにも一つご賞味いただけましたら幸いにございます！<br />
    </p>
    <h3>大会エントリー方法について</h3>
    <p>
      読ム-1グランプリでは合成音声ソフトによる漫才作品の出展を募集しております！<br />
      大会エントリーは下記記載の運営メールアドレスか、twitterやニコニコ動画への投稿で「読ム_１_〇〇※開催年度_参加表明」のタグをつけ、以下の情報を添えて参加申請をお願いいたします。<br />
      １.参加者名（ハンドルネームと別でも、チーム名等でも可です）<br />
      ２.アカウントのURL（ニコニコユーザーIDやTwitterユーザー名等）<br />
      <br />
    </p>
    <h3>大会スケジュール</h3>
    <p>
      ３月10日：　グランプリへのエントリー締め切り<br />
      ４月1日：　応募作品の投稿<br />
      投稿していただいた動画はエントリー順に沿って運営マイリストに登録させていただきます旨、ご了承ください。<br />
      ４月２日～４月９日：　投票期間<br />
      参加者同士で面白かった出展作品への投票を行い、最優秀賞を決定します。 ４月16日(木)：　結果発表<br />
      運営からニコニコ動画にて投稿させていただきます。<br />
    </p>
    <h3>出展作品についてのルール</h3>
    <p>
      １.開催日の ４月１日 に投稿してください<br />
      予定が合わない場合はタイマー投稿をご利用いただいても大丈夫です。<br />
      （タイマー投稿を使用されるときは4/1/00:00とご記入していただければ助かります！）<br />
      ２.合成音声ソフト をを使用してください<br />
      合成音声ソフトと一言で申しましても色々ありますので…「自分で自由に喋らせたいセリフを設定できるソフトウェア、またはそれに類する機能」とさせていただきます。<br />
      また、音声素材については、人の声を録音した物でその言葉がはっきりと聞き取れるような物は全て不可とさせていただきます。効果音としての笑い声や喧騒やノイズに含まれている、ぐらいの物やそのように加工した物は使用OKです。<br />
      ３.未公開、オリジナルの漫才（またはコント等の）作品 を出展してください<br />
      過去作品の再投稿や既存の芸人の漫才や何らかの映像等をVOICEROIDで再現した物などは不可とさせていただきます。<br />
      ４.他イベントとの兼用はできません<br />
      読ム-１の最優秀賞は参加者投票によって決まるのであまり影響はありませんが一応。<br />
      ５.出展作品の再生時間は 1分～5分 に収まるようお願いいたします<br />
      6.投稿する際はタグ「読ム-１_〇〇※開催年度」を付けて投稿してください<br />
      “読ム-１”の”１”は全角なのでご注意ください。ハイフン、アンダーバー、〇〇は半角となります。<br />
    </p>
    <h3>優勝作品の選出について</h3>
    <p>
      各参加者による投票で、最も得票数の多かった作品が優勝になります。<br />
      優勝は運営からの結果発表動画にて発表させていただきます。<br />
      （各参加者の投票先は開示されませんのでご安心を！）<br />
      ・投票ルール<br />
      投票期間は　４月２日０時　～　４月９日０時　となります！<br />
      各参加者は各自３票ずつ持ち票が与えられます。<br />
      その３票を自分の作品以外の面白いと思った作品に投票してください。票の割り振り方は自由です！<br />
      投票する事でその参加者は１票を獲得した物として集計させていただきます。<br />
      投票は投票期間内に下部記載のメールアドレスへ送信してください。<br />
      ・無効票の扱い<br />
      開催日内に動画を投稿され、投票期間終了まで作品が公開されていなければ得票権、投票権は得られません。<br />
      また、その他に大会ルールに抵触した場合も得票権、投票権が無くなります。<br />
      得票権の無い作品への投票も無効票となりますのでご注意ください。<br />
    </p>
    <h3>参加者の皆さまへのお願い</h3>
    <p>
      できれば使用した素材は説明文などに記載していただけるようお願いします。<br />
      ニコニコ動画内の素材を使用された時はコンテンツツリーへの登録も必ずお忘れなくしていただければと思います。<br />
      <br />
    </p>
    <p>
      読ム-１ロゴマーク素材<br />
      <a target="_blank" rel="noreferrer" href="https://seiga.nicovideo.jp/seiga/im7836885">https://seiga.nicovideo.jp/seiga/im7836885</a>
    </p>
  </Layout>
)

export default Page2